import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { Box, Stack, Typography } from '@packages/shared';
import { defineMessages, useIntl } from 'react-intl';
import { RatingTagsFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingTagsFragmentFragmentDoc';
import { Tags } from './Tags';

/* GraphQL */ `
  fragment RatingTagsFragment on RatingTags {
    pro {
      ratingCount
      tag {
        id
        key
        name
      }
    }
    contra {
      ratingCount
      tag {
        id
        key
        name
      }
    }
  }
`;

const messages = defineMessages({
  headlineContra: {
    defaultMessage: 'Nachteile',
    id: 'ratings.productTags.headline.contra',
  },
  headlinePro: {
    defaultMessage: 'Vorteile',
    id: 'ratings.productTags.headline.pro',
  },
});

export type RatingTagsProps = {
  /**
   * rating tags data with pro and contra tags
   */
  ratingTagsData: FragmentType<typeof RatingTagsFragmentFragmentDoc>;
};

/**
 * List of pro and contra Chips in rating overview
 */
export const RatingTags = ({ ratingTagsData }: RatingTagsProps) => {
  const { pro, contra } = getFragmentData(RatingTagsFragmentFragmentDoc, ratingTagsData);
  const { formatMessage } = useIntl();

  return (
    <Stack spacing={1.5}>
      {pro && pro.length > 0 && (
        <Box>
          <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
            {formatMessage(messages.headlinePro)}
          </Typography>
          <Tags tags={pro} />
        </Box>
      )}
      {contra && contra.length > 0 && (
        <Box>
          <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
            {formatMessage(messages.headlineContra)}
          </Typography>
          <Tags tags={contra} />
        </Box>
      )}
    </Stack>
  );
};
